import { axios } from "@Root/API";

export const getProgrammes = params => {
  return axios.get("programs", { params });
};
